var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    width: 600,
    height: 125,
    xlmns: "http://www/w3/org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 580 110 L 600 125 L 0 125 L 0 0",
    fill: "#AB721A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1);
export default __webpack_public_path__ + "static/media/s1.8ae8c64e38b87a3883d352d587c94fcb.svg";
export { ForwardRef as ReactComponent };